import { createStore, applyMiddleware, Store } from 'redux';
import { middleware as reduxPackMiddleware } from 'redux-pack';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers/main';
import { syncedReduxActions } from '../utils/sync-constants';
import { WriteSyncState } from '../connection/sync';
import { Action, GreenroomState } from './types/types';

/* this intercepts synced redux actions, and throws them through our remote sync app
this allows us to fire a redux action on every user's application inside of our greenroom
it also updated a state store in the remote server, that users retrieve when entering the room */
const sync = (store: any) => (next: any) => async (action: Action) => {
	const currentStore = store.getState() as GreenroomState;

	const meeting = currentStore?.SessionReducer?.meeting?.meeting;
	const session = currentStore?.SessionReducer?.session;
	const token = currentStore?.SessionReducer?.token;

	const dataForSyncApp = syncedReduxActions.get(action.type);

	if (
		dataForSyncApp 			// data exists for synced action
		&& meeting				// we're in a (meeting) room
		&& !action.remote		// the action didn't come from sync app
		&& session				// we have a session id assigned to this browser
		&& token) {	// browser is logged on or is broadcasting browser
		const stateToBeWritten = JSON.parse(JSON.stringify(action));
		WriteSyncState(dataForSyncApp, meeting, stateToBeWritten, session, token);
	}

	return next(action);
};

const socket = (store: any) => (next: any) => async (action: Action) => {
	const currentStore = store.getState() as GreenroomState;
	const { debugEnabled, debugSocketCanDispatch } = currentStore.DebugReducer;

	if (!action.socket) {
		return next(action);
	} if (!debugEnabled) {
		return next(action);
	} if (debugSocketCanDispatch) {
		return next(action);
	}
};

const middlewares = applyMiddleware(thunk, reduxPackMiddleware, socket, sync);

const store = createStore(
	rootReducer,
	composeWithDevTools(middlewares),
);

export const testStore = (testData:any): Store<any, any> => createStore(
	rootReducer,
	{
		...composeWithDevTools(middlewares),
		...testData,
	},
);

export default store;
